<template>
  <div class="package-type-list">
    <template v-for="item in packageTypeList">
      <component :is="item.suiteType==2?'section':'div'" class="package-type"
                 :class="'package-type-'+item.suiteType" :key="item.id"
                 v-if="item.isShow"
      >
        <ul>
          <li :class="pItem.id == chooseId? 'active': ''" v-for="pItem in item.suites"
              :key="pItem.id"
              @click="serviceBuy(pItem)">
            <div class="leaf"  v-if="pItem.presentedTsCount>0">
              <p>送{{ pItem.presentedTsCount }}个</p>
            </div>
            <div class="package-item-content">
              <div class="number">
                <div class="total">共 <b>{{ pItem.tsCount+pItem.presentedTsCount }}</b> 个</div>
                <div class="period" >使用期限{{pItem.validityPeriod==0?'永久': pItem.validityPeriod +'天'}}</div>
              </div>
              <div class="amount">
                <div class="consume">
                  <b>¥{{ pItem.payAmount }}</b>
                  <span v-if="pItem.payAmount!==pItem.amount">¥{{ pItem.amount }}</span>
                </div>
                <p v-if="pItem.payAmount!==pItem.amount">立省 ¥ {{pItem.amount-pItem.payAmount}}元</p>
              </div>
            </div>
          </li>
        </ul>
      </component>
    </template>
  </div>
</template>

<script>
import {getSuiteCommon} from '@/common/suite'
import Vue from 'vue'
export default {
  name: "tagView",
  data() {
    return {
      chooseId: '',
      packageTypeList: [],
      cardInfo: {}
    }
  },
  created() {
  },
  methods: {
    // 服务包
    async dealListCommon() {
      return new Promise((reslove, reject) => {
          getSuiteCommon().then(res => {
            this.packageTypeList=res.packageTypeList
            this.$emit('titleText', res.titleText)
            reslove()
          }).catch(() => {
            reject()
          })
      })
    },
    // 右侧服务包购买
    serviceBuy(item) {
      this.$emit('serviceBuy', item)
    },
  }
};
</script>

<style scoped lang="less">
.package-type-list {
  .package-type {
    padding-bottom: 5px;

    .package-type-title {
      display: flex;

      .title {
        margin-right: 16px;
        display: flex;
        align-items: center;
        font-size: 600;
        font-size: 16px;
        line-height: 22px;

        &::before {
          content: '';
          width: 2px;
          height: 12px;
          background-color: #005CE6;
          margin-right: 8px;
        }
      }

      .period {
        color: #84868C;
        display: flex;
        align-items: flex-end;

        b {
          color: #F43F3F;
          font-size: 16px;
        }
      }
    }

    ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      li {
        cursor: pointer;
        border: 1px solid #E8E9EB;
        border-radius: 14px;
        height: 106px;
        min-width: 48%;
        padding: 12px;
        box-sizing: border-box;
        position: relative;
        background: #fff;

        .leaf {
          position: absolute;
          right: 0;
          top: 0;
          display: flex;

          p {
            height: 24px;
            color: #fff;
            font-size: 12px;
            line-height: 24px;
          }

          &::before {
            display: block;
            content: '';
            height: 24px;
            width: 30px;
            background-size: cover;
            background-repeat: no-repeat;
          }

          &::after {
            display: block;
            content: '';
            height: 31px;
            width: 15px;
            background-size: cover;
            background-repeat: no-repeat;
          }
        }

        .package-item-content {
          padding-top: 10px;

          .number {
            display: flex;
            align-items: flex-end;
            justify-content: space-between;

            .total {
              color: #6B748F;

              b {
                font-size: 20px;
                color: #191D32;
                font-weight: bold;
              }
            }

            .period {
              font-size: 12px;
              color: #84868C;
              font-family: "SimHei", "Microsoft YaHei";
            }
          }

          .amount {
            display: flex;
            align-items: flex-end;
            justify-content: space-between;

            .consume {
              padding-top: 10px;
              padding-right: 6px;
              display: flex;
              flex-direction: column;

              b {
                color: #F33E3E;
                font-size: 18px;
              }

              span {
                font-size: 12px;
                color: #B8BABF;
                text-decoration: line-through;
              }
            }

            p {
              box-sizing: border-box;
              background-color: #F8FAFC;
              font-size: 12px;
              color: #6B748F;
              padding: 4px 6px;
              min-width: 95px;
              text-align: center;
              border-radius: 4px;
            }
          }
        }

        &.active {
          background-repeat: no-repeat;

          .package-item-content {
            .amount {
              p {
                background-color: #fff;
              }
            }
          }
        }
      }
    }

    //标准包
    &.package-type-1 {
      ul {
        li {
          .leaf {
            p {
              background-color: #1A75F3;
            }

            &::before {
              background-image: url(../../../assets/images/buy/leafLeft3.png);
            }

            &::after {
              background-image: url(../../../assets/images/buy/leafRight3.png);
            }
          }

          &:hover {
            border-color: #1A75F3;
          }

          &.active {
            border-color: #1A75F3;
            background-color: #F9F0FE;
            background-image: url('../../../assets/images/buy/check3.png');
          }
        }
      }
    }

    //活动包
    &.package-type-2:nth-of-type(1) {
      ul {
        li {
          .leaf {
            p {
              background-color: #FF5C5A;
            }

            &::before {
              background-image: url(../../../assets/images/buy/leafLeft2.png);
            }

            &::after {
              background-image: url(../../../assets/images/buy/leafRight2.png);
            }
          }

          &:hover {
            border-color: #FF5C5A;
          }

          &.active {
            border-color: #FF5C5A;
            background-color: #FFF2E9;
            background-image: url('../../../assets/images/buy/check2.png');
          }
        }
      }
    }

    &.package-type-2:nth-of-type(2) {
      ul {
        li {
          .leaf {
            p {
              background-color: #30BF13;
            }

            &::before {
              background-image: url(../../../assets/images/buy/leafLeft4.png);
            }

            &::after {
              background-image: url(../../../assets/images/buy/leafRight4.png);
            }
          }

          &:hover {
            border-color: #30BF13;
          }

          &.active {
            border-color: #30BF13;
            background-color: #fff;
            background-image: url('../../../assets/images/buy/check4.png');
          }
        }
      }
    }

    //新用户
    &.package-type-3 {
      ul {
        li {
          .leaf {
            p {
              background-color: #FF8801;
            }

            &::before {
              background-image: url(../../../assets/images/buy/leafLeft1.png);
            }

            &::after {
              background-image: url(../../../assets/images/buy/leafRight1.png);
            }
          }

          &:hover {
            border-color: #FF8801;
          }

          &.active {
            border-color: #FF8801;
            background-color: #FFFEF4;
            background-image: url('../../../assets/images/buy/check1.png');
          }
        }
      }


    }


  }
}

</style>
